module.exports = __webpack_public_path__ + "bph5/img/cesuan.38e7e1d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cesuan.gif
// module id = 1d9U
// module chunks = 27